<template>
  <div class="animated fadeIn">
    <div class="loading" v-if="loading">
      <square-loader :loading="true" color="#26A65B" size="50px"></square-loader>
    </div>

    <b-card>
      <b-row>
        <b-col cols='12' sm="7">
          <b-form-group v-bind:label="$t('outlet')" :label-cols="2" label-class="text-right" :horizontal="true">
            <v-select v-model="outlet" :options="outlets[$session.get('lang')]">
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="3">
          <b-form-group v-bind:label="$t('date')" :label-cols="2" label-class="text-right" :horizontal="true">
            <date-range-picker
              :startDate="start_date"
              :endDate="end_date"
              @update="updateDate"
              :locale-data="locale"
            >
            </date-range-picker>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="2">
          <b-button variant="success" v-on:click="refresh"> <i class="fa fa-search"></i> {{$t('search')}}</b-button>
        </b-col>
        <b-col cols='12' sm="12">
          <div class="process-container bg-secondary">
            <div class="current bg-primary" :style="'width: ' + current + '%'"></div>
            <div class="target bg-danger" id="target" :style="'margin-left: ' + target + '%'"></div>
            <b-tooltip :show.sync="show_target" target="target" placement="bottom">
              {{target_sales | numeral('0,0')}}
            </b-tooltip>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right font-3xl">
              <i class="fa fa-money"></i>
            </div>
            <h4 class="mb-0">{{total_sales | numeral('0,0')}}</h4>
            <p>{{$t('total_sale')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="6">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right font-3xl">
              <i class="fa fa-shopping-basket"></i>
            </div>
            <h4 class="mb-0">{{total_cheque | numeral('0,0')}}</h4>
            <p>{{$t('total_cheque')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="6">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right font-3xl">
              <i class="fa fa-bar-chart"></i>
            </div>
            <h4 class="mb-0">{{total_sales/total_cheque | numeral('0,0.00')}}</h4>
            <p>{{$t('average_cheque')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="6">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right font-3xl">
              <i class="fa fa-bullhorn"></i>
            </div>
            <h4 class="mb-0">{{sos | numeral('0,0.00')}}</h4>
            <p>{{$t('sos')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="12">
        <hr/>
      </b-col>

      <b-col sm="12" lg="6">
        <pie :labels="sale_by_channel_labels[$session.get('lang')]" :datasets="sale_by_channel_datasets"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('sales_by_channel')}}</h2>
        </div>
      </b-col>

      <b-col sm="12" lg="6">
        <pie :labels="sale_by_type_labels[$session.get('lang')]" :datasets="sale_by_type_datasets"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('sales_by_type')}}</h2>
        </div>
      </b-col>

      <b-col sm="12">
        <hr/>
      </b-col>

      <b-col sm="12" lg="6">
        <pie :labels="cheque_by_channel_labels[$session.get('lang')]" :datasets="cheque_by_channel_datasets"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('cheque_by_channel')}}</h2>
        </div>
      </b-col>

      <b-col sm="12" lg="6">
        <pie :labels="cheque_by_type_labels[$session.get('lang')]" :datasets="cheque_by_type_datasets"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('cheque_by_type')}}</h2>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<style scoped>
  .process-container {
    width: 100%;
    height: 35px;
  }
  .process-container .current {
    height: 35px;
    -webkit-transition: width 1s; /* Safari */
    transition:width 1s;
  }
  .process-container .target {
    width: 2px;
    height: 35px;
    margin-top: -35px;
    -webkit-transition: margin-left 1s; /* Safari */
    transition: margin-left 1s;
  }
  .chart-title {
    color: #6c6c6c;
    padding: 5px;
  }
  .loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99999;
    padding-top: 300px;
  }
</style>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import Bar from './charts/Bar'
import Pie from './charts/Pie'
import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import {history, store} from '@/api/report'

export default {
  name: 'SalesHistory',
  components: {
    DateRangePicker,
    Bar,
    Pie,
    SquareLoader
  },
  data: function () {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      total_sales: 0,
      total_cheque: 0,
      sos: 0,
      target_sales: 0,
      current: 0,
      target: 100,
      show_target: true,
      languages: Object.keys(this.$i18n.messages),
      pie_data: {
        backgroundColor: [
          '#20a8d8',
          '#f86c6b',
          '#ffc107',
          '#9B59B6',
          '#73818f',
          '#4dbd74'
        ],
        data: []
      },
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      sale_by_type_labels: {},
      sale_by_type_datasets: {},
      cheque_by_channel_labels: {},
      cheque_by_channel_datasets: {},
      cheque_by_type_labels: {},
      cheque_by_type_datasets: {}
    }
  },
  methods: {
    /**
     * Update data
     */
    updateData () {
      this.$Progress.start()
      let params = {
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date
      }
      history(params).then((response) => {
        this.total_cheque = response.data.data.total_cheque
        this.target_sales = response.data.data.target
        this.total_sales = response.data.data.total_sale
        this.sos = response.data.data.sos
        this.sale_by_channel_datasets[0].data = [
          response.data.data.sales.online,
          response.data.data.sales.call_center,
          response.data.data.sales.offline,
          response.data.data.sales.offline_go_jek,
          response.data.data.sales.grab
        ]
        this.sale_by_type_datasets[0].data = [
          response.data.data.sales.takeaway,
          response.data.data.sales.delivery,
          response.data.data.sales.eat_in
        ]
        this.cheque_by_channel_datasets[0].data = [
          response.data.data.bill.online,
          response.data.data.bill.call_center,
          response.data.data.bill.offline,
          response.data.data.bill.offline_go_jek,
          response.data.data.bill.grab
        ]
        this.cheque_by_type_datasets[0].data = [
          response.data.data.bill.takeaway,
          response.data.data.bill.delivery,
          response.data.data.bill.eat_in
        ]

        for (let i in this.languages) {
          this.sale_by_channel_labels[this.languages[i]] = [
            this.$t('online', this.languages[i]) + ' ' + ((response.data.data.sales.online / response.data.data.total_sale) * 100).toFixed(2) + '%',
            this.$t('call_center', this.languages[i]) + ' ' + ((response.data.data.sales.call_center / response.data.data.total_sale) * 100).toFixed(2) + '%',
            this.$t('offline', this.languages[i]) + ' ' + ((response.data.data.sales.offline / response.data.data.total_sale) * 100).toFixed(2) + '%',
            this.$t('offline_go_jek', this.languages[i]) + ' ' + ((response.data.data.sales.offline_go_jek / response.data.data.total_sale) * 100).toFixed(2) + '%',
            this.$t('grab', this.languages[i]) + ' ' + ((response.data.data.sales.grab / response.data.data.total_sale) * 100).toFixed(2) + '%'
          ]
          this.sale_by_type_labels[this.languages[i]] = [
            this.$t('takeaway', this.languages[i]) + ' ' + ((response.data.data.sales.takeaway / response.data.data.total_sale) * 100).toFixed(2) + '%',
            this.$t('delivery', this.languages[i]) + ' ' + ((response.data.data.sales.delivery / response.data.data.total_sale) * 100).toFixed(2) + '%',
            this.$t('eat_in', this.languages[i]) + ' ' + ((response.data.data.sales.eat_in / response.data.data.total_sale) * 100).toFixed(2) + '%'
          ]
          this.cheque_by_channel_labels[this.languages[i]] = [
            this.$t('online', this.languages[i]) + ' ' + ((response.data.data.bill.online / response.data.data.total_cheque) * 100).toFixed(2) + '%',
            this.$t('call_center', this.languages[i]) + ' ' + ((response.data.data.bill.call_center / response.data.data.total_cheque) * 100).toFixed(2) + '%',
            this.$t('offline', this.languages[i]) + ' ' + ((response.data.data.bill.offline / response.data.data.total_cheque) * 100).toFixed(2) + '%',
            this.$t('offline_go_jek', this.languages[i]) + ' ' + ((response.data.data.bill.offline_go_jek / response.data.data.total_cheque) * 100).toFixed(2) + '%',
            this.$t('grab', this.languages[i]) + ' ' + ((response.data.data.bill.grab / response.data.data.total_cheque) * 100).toFixed(2) + '%'
          ]
          this.cheque_by_type_labels[this.languages[i]] = [
            this.$t('takeaway', this.languages[i]) + ' ' + ((response.data.data.bill.takeaway / response.data.data.total_cheque) * 100).toFixed(2) + '%',
            this.$t('delivery', this.languages[i]) + ' ' + ((response.data.data.bill.delivery / response.data.data.total_cheque) * 100).toFixed(2) + '%',
            this.$t('eat_in', this.languages[i]) + ' ' + ((response.data.data.bill.eat_in / response.data.data.total_cheque) * 100).toFixed(2) + '%'
          ]
        }

        this.updateProcess()
      }).catch((error) => {
        this.$notify({
          title: this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        })
      }).then(() => {
        this.loading = false
        this.$Progress.finish()
      })
    },
    /**
     * Update current and target sale
     */
    updateProcess () {
      this.show_target = false
      let goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales
      this.current = this.total_sales * 100 / goal
      this.target = this.target_sales * 100 / goal
      setTimeout(() => {
        this.show_target = true
      }, 2000)
    },
    /**
     * Refresh data
     */
    refresh () {
      this.updateData()
      this.updateProcess()
    },
    /**
     * Update Date
     */
    updateDate (val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD')
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD')
      this.refresh()
    }
  },
  created: function () {
    for (let i in this.languages) {
      this.sale_by_channel_labels[this.languages[i]] = [
        this.$t('online', this.languages[i]),
        this.$t('call_center', this.languages[i]),
        this.$t('offline', this.languages[i]),
        this.$t('offline_go_jek', this.languages[i]),
        this.$t('grab', this.languages[i])
      ]
      this.sale_by_type_labels[this.languages[i]] = [
        this.$t('takeaway', this.languages[i]),
        this.$t('delivery', this.languages[i]),
        this.$t('eat_in', this.languages[i])
      ]
      this.cheque_by_channel_labels[this.languages[i]] = [
        this.$t('online', this.languages[i]),
        this.$t('call_center', this.languages[i]),
        this.$t('offline', this.languages[i]),
        this.$t('offline_go_jek', this.languages[i]),
        this.$t('grab', this.languages[i])
      ]
      this.cheque_by_type_labels[this.languages[i]] = [
        this.$t('takeaway', this.languages[i]),
        this.$t('delivery', this.languages[i]),
        this.$t('eat_in', this.languages[i])
      ]
    }
    let pieSalesChannelData = this._.cloneDeep(this.pie_data)
    let pieSalesTypeData = this._.cloneDeep(this.pie_data)
    let pieBillChannelData = this._.cloneDeep(this.pie_data)
    let pieBillTypeData = this._.cloneDeep(this.pie_data)
    this.sale_by_channel_datasets = [pieSalesChannelData]
    this.sale_by_type_datasets = [pieSalesTypeData]
    this.cheque_by_channel_datasets = [pieBillChannelData]
    this.cheque_by_type_datasets = [pieBillTypeData]
    this.$Progress.start()
    store().then((response) => {
      this.outlets = {}
      for (let l in this.languages) {
        this.outlets[this.languages[l]] = []
        this.outlets[this.languages[l]].push({
          label: this.$t('all', this.languages[l]),
          value: null
        })
        for (let i in response.data.data) {
          this.outlets[this.languages[l]].push({
            label: response.data.data[i].name,
            value: response.data.data[i].store_code
          })

          if (this.outlet.value == response.data.data[i].store_code) {
            this.outlet.label = response.data.data[i].name
          }
        }
      }

      this.refresh()

      setInterval(() => {
        this.refresh()
      }, 5 * 60 * 1000)
    }).catch((error) => {
      this.$notify({
        title: this.$t('error'),
        text: error.response.data.message,
        type: 'error'
      })
    }).then(() => {
      this.$Progress.finish()
    })
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SalesHistory.vue